// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-zG80_P"};